<template>
  <div class="bg333 LeftFixedBox">
    <!-- <div class="header" > -->
    <div class="header txtshadow" :style="{backgroundImage:`url(${img})`}">导航</div>
    <div class="item">
      <ul>
        <li v-for="v in data" v-bind:key="v.Id" @click.stop="changeStorey(v)" class="navLis">
          <div class="btn">
            <div class="navname txtshadow ihover">{{v.StoreyTitle}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    name: "LeftFixedBox",
    data: function () {
      return {
        list: [],
        img: require("../assets/left-nav-bg.png")
      };
    },
    props: {
      data: {
        type: Array,
        default: []
      }
    },
    methods: {
      changeStorey(v) {
        this.$emit("change", v);
      }
    }
  };
</script>
<style lang="less" scoped>
  @rowheight: 105px;
  @top: 150px;

  .bg333 {
    width: @rowheight;
    background: #b4bbc5;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .LeftFixedBox {
    position: fixed;
    border-radius: 5px;
    left: calc((100vw - 1200px) / 2 - 125px);
    top: @top;
    z-index: 500;
    height: auto !important;
    color: rgba(68, 68, 68, 1);
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(238, 238, 238, 1);
    border-radius: 0px 0px 2px 2px;
  }

  .header {
    font-size: 20px;
    font-weight: 600;
    height: 48px;
    color: rgba(255, 255, 255, 1);
    line-height: 50px;
    -moz-background-size: 100% 100%;
    background-size: 100% 100%;
  }

  .item {
    width: 100%;
    height: auto;
    line-height: @rowheight;
    background-color: white;

    ul {
      margin: 0px;

      li {
        width: 100%;
        // height: @rowheight;
        cursor: pointer;
      }

      :not(:last-child) {
        position: relative;

        &:after {
          content: "";
          width: 101px;
          height: 1px;
          background: linear-gradient(to right,
              #ffffff 0%,
              #eeeeee 20%,
              #999999 50%,
              #eeeeee 80%,
              #ffffff 100%);
          position: absolute;
          bottom: -1px;
          transform: translateX(-50%);
        }
      }
    }
  }

  .hoverm {
    color: rgba(15, 110, 233, 1);
  }

  .navname {
    width: 100%;
    height: 48px;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 1px;
    padding: 24px 2px;
  }

  .txtshadow {
    text-shadow: 0px 2px 15px rgba(238, 238, 238, 1);
  }
    .navLis{
        // height: 74px;
        >div{
            height: 100%;
            >div{
                padding: 15px 30px;
                height: 100%;
            }
        }
    }
</style>
